module.exports = __webpack_public_path__ + "static/media/logo.f3a60fc1.jpeg";